/** Montant en centimes → `12,50 €` (deux décimales, virgule française). */
export const formatCentsAsEuros = (cents: number): string =>
  `${(cents / 100).toFixed(2).replace('.', ',')} €`

/** Durée en secondes → `3 h 05`, ou `45 min` sous l'heure. */
export const formatSecondsAsHoursMinutes = (seconds: number): string => {
  // Arrondir le total d'abord : arrondir le reste après extraction des heures donnerait `1 h 60`.
  const totalMinutes = Math.round(seconds / 60)
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60
  return hours > 0 ? `${hours} h ${String(minutes).padStart(2, '0')}` : `${minutes} min`
}
